import Supplier from "../Supplier";

export const supplierDefaultValues: Supplier = {
  Id: 0,
  Gsdb: "",
  Name: "",

  DefaultLoadingTime: "",

  // Address
  Street: "",
  City: "",
  Zipcode: "",

  // Country
  CountryID: 0,
  CountryCode: "",

  // Region / Area
  Region: "",
  AreaCode: "",
  ZipArea: "",

  // GeoCoordinates
  Latitude: undefined,
  Longitude: undefined,
  MGLatitude: undefined,
  MGLongitude: undefined,

  // Alt Location
  AltLocationForContainerReturns: false,

  // Alt Address
  AltStreet: "",
  AltCity: "",
  AltZipcode: "",

  // Alt Country
  AltCountryID: 0,
  AltCountryCode: "",

  // Alt Region / Area
  AltRegion: "",
  AltAreaCode: "",
  AltZipArea: "",

  // Alt GeoCoordinates
  AltLatitude: undefined,
  AltLongitude: undefined,
  AltMGLatitude: undefined,
  AltMGLongitude: undefined,

  // Opening Times
  OpeningTimes: [],
};
